import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from 'src/store/selectors';

export const emergencyAccessList = createSelector(getOrganization, (organization): string[] => {
  if (organization === undefined) return [];
  return organization.emergencyAccessList;
});
